import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMultipleChoice = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M8 8.00065H14Z",
			fill: "#2563EB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 12.0007H14Z",
			fill: "#2563EB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2 4.00065C2 3.63246 2.29848 3.33398 2.66667 3.33398H4.66667C5.03486 3.33398 5.33333 3.63246 5.33333 4.00065V6.00065C5.33333 6.36884 5.03486 6.66732 4.66667 6.66732H2.66667C2.29848 6.66732 2 6.36884 2 6.00065V4.00065Z",
			fill: "#2563EB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 8.00065H14M8 12.0007H14M8 4.00065L14 4.00065M2 10.7371L3.2649 12.0007C3.87328 10.9369 4.71522 10.0251 5.72725 9.33398M2.66667 6.66732H4.66667C5.03486 6.66732 5.33333 6.36884 5.33333 6.00065V4.00065C5.33333 3.63246 5.03486 3.33398 4.66667 3.33398H2.66667C2.29848 3.33398 2 3.63246 2 4.00065V6.00065C2 6.36884 2.29848 6.66732 2.66667 6.66732Z",
			stroke: "#2563EB",
			strokeWidth: 2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgMultipleChoice);
export default ForwardRef;
